import { Typography } from "@mui/material";
import type { FC } from "react";
import { ReviewsTable } from "./reviews-table";

export const PreviousReviewsTab: FC = () => (
  <>
    <Typography variant="body2" sx={{ mb: 4 }}>
      These are Communications you were previously asked to review, that have now been published.
      Creators can publish Communications without the review being completed.
    </Typography>
    <ReviewsTable variant="previous" />
  </>
);
